import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { connect } from 'react-redux'
import { updateItem } from '../../../actions/relationActions';
import { hideModal } from '../../../actions/modalsActions';
import CyberSecurity from '../../../apis/cyberSecurityData';
import "react-datepicker/dist/react-datepicker.css";
import AdminForm from './AdminForm';

let AdminEdit = (props) => {
    //redux store state
    const accessToken = useSelector(state => state.accessToken);
    const [item, setItem] = useState({});

    const getItemData = async () => {
        const response = await CyberSecurity.get(`/cyberdata/${props.item._id}`, {
            headers: {
                Authorization: 'Bearer ' + accessToken
            }
        });

        if (response.data.error) return console.log(response.data.error)

        setItem(response.data);
    }

    useEffect(() => {
        getItemData();
    }, [])

    const onSubmit = async (updates, actor) => {

        const response = await CyberSecurity.post('/edititem', { updates, itemId: props.item._id, actor }, {
            headers: {
                Authorization: `Bearer ${props.accessToken}`
            }
        })

        if (response.data.error) return console.log({ error: response.data.error })

        props.updateItem(response.data)
        props.hideModal();
    }



    return (
        item._id ? <AdminForm initialValues={item} onFormSubmit={onSubmit} /> : null
    )
}


const mapStateToProps = (state, ownProps) => {
    return {
        accessToken: state.accessToken
    }
}

export default connect(mapStateToProps, { updateItem, hideModal })(AdminEdit);
